import React from "react";
import { Card, Typography } from "antd";

const RefundPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Refund & Return Policy</Typography.Title>

      <Typography.Paragraph>
        Effective Date: <strong>November 15, 2025</strong>
      </Typography.Paragraph>

      <Typography.Title level={4}>1. Return Window</Typography.Title>
      <Typography.Paragraph>
        Returns accepted within <strong>7 days</strong> of delivery.
      </Typography.Paragraph>

      <Typography.Title level={4}>2. Eligible Returns</Typography.Title>
      <Typography.Paragraph>
        - Wrong item delivered<br />
        - Damaged product<br />
        - Manufacturing defects<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>3. Non-Returnable Items</Typography.Title>
      <Typography.Paragraph>
        - Hygiene products<br />
        - Used or opened items<br />
        - Items marked 'Non-returnable'<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>4. Refund Timeline</Typography.Title>
      <Typography.Paragraph>
        - UPI / Wallet: 1–3 days<br />
        - Card / Netbanking: 3–7 business days<br />
        - COD refunds: through bank account<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>5. Contact</Typography.Title>
      <Typography.Paragraph>
        Email: dropkartworld29@gmail.com<br />
        Phone: +91 90322 25598
      </Typography.Paragraph>
    </Card>
  </div>
);

export default RefundPage;
